import { render, staticRenderFns } from "./ManagePayrollContributions.vue?vue&type=template&id=459710a3"
import script from "./ManagePayrollContributions.vue?vue&type=script&lang=ts"
export * from "./ManagePayrollContributions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports